import React from "react";
import { BRAND_COLORS } from "../../theme/brandTheme";

export default function BrandLogoBadge({
  size = 96,
  radius = 18,
  padding = 6,
  background = BRAND_COLORS.logoBg,
  border = `1px solid ${BRAND_COLORS.border}`,
  shadow = `0 0 20px ${BRAND_COLORS.primaryGlow}`,
  image = `${process.env.PUBLIC_URL}/tobe-esports.png`,
  alt = "TO BE NUMBER ONE ESPORTS",
}) {
  return (
    <img
      src={image}
      alt={alt}
      onError={(e) => {
        e.currentTarget.src = image;
      }}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        borderRadius: radius,
        border,
        boxShadow: shadow,
        background,
        padding,
      }}
    />
  );
}
